import './FancyCheckbox.css';
import { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';


export default function FancyCheckbox({startChecked=false, label="Checkbox Text", checkChangeCallback = null}){
    const [checked, setChecked] = useState(startChecked);
    const onCheckedChanged = ()=>{
        setChecked(!checked);
        if(checkChangeCallback !== null) checkChangeCallback(!checked);
    }
    return (
        <>
            <div className={"fancy-checkbox margin-centered"+ (checked ? " checked" : "")} onClick={onCheckedChanged}>
                <FontAwesomeIcon icon={"fa-regular " + (checked ? "fa-square-check" : "fa-square")} />
                <div className="fancy-checkbox-label">{label}</div>
            </div>
        </>
    )
}